import { useEffect, useRef, useCallback } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SignatureMarquee from "@/components/SignatureMarquee";
import Manifesto from "@/components/Manifesto";
import Ecosystem from "@/components/Ecosystem";
import Work from "@/components/Work";
import Capabilities from "@/components/Capabilities";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  const navigate = useCallback((href) => {
    const target = href === "#top" ? 0 : document.querySelector(href);
    if (target === 0) {
      lenisRef.current?.scrollTo(0, { duration: 1.4 });
    } else if (target) {
      lenisRef.current?.scrollTo(target, { offset: -20, duration: 1.4 });
    }
  }, []);

  return (
    <div className="App grain relative min-h-screen bg-ink text-chalk">
      <Navbar onNavigate={navigate} />
      <main>
        <Hero onNavigate={navigate} />
        <SignatureMarquee />
        <Manifesto />
        <Work onNavigate={navigate} />
        <Ecosystem />
        <Capabilities />
        <Contact />
      </main>
      <Footer onNavigate={navigate} />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
